import './index.scss';
import 'components/button_follow';
import 'components/freemium/block_message';
import 'components/lesson_player/faq';
import 'components/video_player';
import 'styles/components/_responsive-embed.scss';
import FeedbackForm from 'components/feedback_form';
import { runPreTextScript } from 'components/lesson_freemium/pre_text';
// eslint-disable-next-line import/extensions
import LessonNotesTab from './notes/index.js';
import { handleApiError } from 'utils/api_error_handler';

export default class LessonPlayer {
  static start(context) {
    LessonPlayer._bind(context);
    new FeedbackForm(context);
    new LessonNotesTab(context);

    if (gon.flags.freemium_lessons) {
      runPreTextScript();
    }
  }

  static _bind(context) {
    $('.js-lesson-progress', context).on('click', event => {
      const $target = $(event.currentTarget);
      const lessonId = $target.data('lesson-id');
      const hasStudied = $target.data('studied');
      const finishedTime = hasStudied ? '' : new Date();

      Thor.UserLessonProgress.update(
        { lesson_id: lessonId },
        {
          data: {
            progress: {
              finished_studying_at: finishedTime
            }
          }
        }
      )
        .then(() => {
          $target.data('studied', !hasStudied);
          $target.toggleClass('q-watched');
          $target.find('.q-icon').toggleClass('q-icon-check-circle-solid');
          $target.find('.q-icon').toggleClass('q-icon-check-circle');
          $target
            .find('.q-lesson-progress-btn')
            .text(!hasStudied ? 'Aula assistida' : 'Marcar como assistida');

          if (!hasStudied) {
            toastr.success('Marcação realizada com sucesso');
          } else {
            toastr.info('A aula agora está como não assistida.');
          }
        })
        .catch(({ response }) => {
          handleApiError(
            'Ops! Não foi possível marcar essa aula como estudada nesse momento!',
            response
          );
        });
    });
  }
}
